// ALV
export const DEFAULT_INPUT_CURRENCY = 'ALV'
// DUSD
export const DEFAULT_OUTPUT_CURRENCY = '0x79499BbEA6DeAa580ABBEB6A902f7C3045495967'
